import ColorButton from './ColorButton';
import LengthPicker from './Length';
import Slider from './Slider';
import NumericPicker from './Numeric';
import XPath from './XPath';
import DateTime from './DateTime';
import MultiSelect from './MultiSelect';
import LocalFile from './LocalFile';
import RepositoryPicker from './RepositoryPicker';
import DataSelect from './DataSelect';
import DataGridSelectFormInput from './DataGridSelect';
import DiagramSelect from './DiagramSelect';
import Text from './Text';
import Switch from './Switch';
import Signature from './Signature';
import Checkbox from './Checkbox';
import RadioGroup from './RadioGroup';
import Filter from './Filter';
import Rating from './Rating';
var Input = {
  ColorButton: ColorButton,
  LengthPicker: LengthPicker,
  Slider: Slider,
  NumericPicker: NumericPicker,
  XPath: XPath,
  DateTime: DateTime,
  MultiSelect: MultiSelect,
  LocalFile: LocalFile,
  RepositoryPicker: RepositoryPicker,
  DataSelect: DataSelect,
  DataGridSelectFormInput: DataGridSelectFormInput,
  DiagramSelect: DiagramSelect,
  Text: Text,
  Switch: Switch,
  Signature: Signature,
  RadioGroup: RadioGroup,
  Checkbox: Checkbox,
  Filter: Filter,
  Rating: Rating
};
export default Input;